import { Pagination } from '@/components/@next/Pagination/Pagination';
import StandaloneLoader from '@/components/@next/StandaloneLoader';
import { buildQueryParamsHook } from '@/hooks/useQueryParams';
import routes from '@/routes/routes';
import { z_stringToNumberStrict } from '@/utils/zod';
import { useBlogPostsCountQuery, useBlogPostsQuery } from '../blog.api';
import { BlogPostItem } from '../components/BlogPostItem';
import { BlogRecentPostItem } from '../components/BlogRecentPostItem';

const recentPostsLimit = 5;
const perPage = 3;

const useBlogQueryParams = buildQueryParamsHook({
  offset: z_stringToNumberStrict().default('0'),
});

export const BlogHome = () => {
  const parsedParams = useBlogQueryParams();
  const { offset } = parsedParams;
  const currentPage = Math.floor(offset / perPage) + 1;

  const { data: postsCount } = useBlogPostsCountQuery({});
  const { isLoading: recentPostsLoading, data: recentPosts } = useBlogPostsQuery({
    take: recentPostsLimit,
  });
  const { isLoading: postsLoading, data: posts } = useBlogPostsQuery({
    skip: offset,
    take: perPage,
  });

  const urlForPage = (page: number) => {
    return routes.blog({ offset: Math.max(0, page - 1) * perPage });
  };
  return (
    <div className="py-10 flex flex-col items-start">
      <div className="w-full">
        {recentPostsLoading && <StandaloneLoader />}
        {!offset && recentPosts && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-1 items-stretch mb-20">
            <div>
              <BlogRecentPostItem post={recentPosts[0]} />
            </div>
            <div className="grid grid-cols-2 gap-1 max-h-full">
              {recentPosts.slice(1).map((post) => (
                <div key={post.id}>
                  <BlogRecentPostItem post={post} />
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
      <div>
        {postsLoading ? (
          <StandaloneLoader />
        ) : (
          <>
            {posts ? (
              <>
                <h1 className="font-bold text-3xl mb-5">Latest posts</h1>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
                  {posts.map((post) => (
                    <div key={post.id}>
                      <BlogPostItem post={post} />
                    </div>
                  ))}
                </div>
              </>
            ) : (
              <h1>No Posts available</h1>
            )}
          </>
        )}
      </div>
      <div className="flex w-full justify-center pt-8 pb-5">
        {!!postsCount && (
          <div>
            <Pagination
              current={currentPage}
              total={postsCount}
              pageSize={perPage}
              hrefBuilder={urlForPage}
            />
          </div>
        )}
      </div>
    </div>
  );
};
